import { graphql } from "@graphql-generated/gql";

export const SetCurrentClientConfigGraphql = graphql(`
    mutation SetCurrentClientConfig($configKey: String!, $configValue: String!) {
        setCurrentClientConfig(configKey: $configKey, configValue: $configValue) {
            configKey
            value
        }
    }
`);

export const ResetCurrentClientConfigGraphql = graphql(`
    mutation ResetCurrentClientConfig($configKey: String!) {
        resetCurrentClientConfig(configKey: $configKey)
    }
`);
